import type { App } from "vue";

let ghostElement: HTMLElement | null = null;
let ghostApp: App | null = null;

export const removeDragGhost = () => {
  ghostElement?.remove();
  ghostApp?.unmount();
  ghostElement = null;
  ghostApp = null;
};

export const setDragGhost = (element: HTMLElement, app: App | null = null) => {
  removeDragGhost();
  ghostElement = element;
  ghostApp = app;
};
